var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#AFC5FC",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#DCE5FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 19.6664L17.7614 22.8805C17.8489 22.9242 17.8926 22.9461 17.9385 22.9547C17.9791 22.9623 18.0208 22.9623 18.0614 22.9547C18.1073 22.9461 18.151 22.9242 18.2384 22.8805L24.6666 19.6664M11.3333 16.3331L17.7614 13.119C17.8489 13.0752 17.8926 13.0534 17.9385 13.0448C17.9791 13.0372 18.0208 13.0372 18.0614 13.0448C18.1073 13.0534 18.151 13.0752 18.2384 13.119L24.6666 16.3331L18.2384 19.5471C18.151 19.5909 18.1073 19.6127 18.0614 19.6213C18.0208 19.6289 17.9791 19.6289 17.9385 19.6213C17.8926 19.6127 17.8489 19.5909 17.7614 19.5471L11.3333 16.3331Z",
    stroke: "#2064FA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.e899690390e14d0d701c9f0cb8f296d3.svg";
export { ForwardRef as ReactComponent };